lmApp
  .controller('TileExternalAppController', ['$scope', '$rootScope', '$interval', 'ShowcaseService', 'ToastService',
    function ($scope, $rootScope, $interval, ShowcaseService, ToastService) {

      $scope.namespace = 'stockmob';
      $scope.tile = $scope.$parent.tile;
      $scope.loading = false;

      $scope.validate = function (banner) {
        $scope.validateFields = {};

        if (!banner._PrivateData.uiTitle) {
          $scope.validateFields.uiTitle = true;
        }

        if (!banner._PrivateData.picture) {
          $scope.validateFields.picture = 'Required filed';
        }

        if (!banner._PrivateData.selectedApp.id) {
          $scope.validateFields.app = 'Required filed';
        }

        return $scope.validateFields;
      };

      $scope.updateWidget = function (tile) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(tile.banner))) {
          return;
        }

        ShowcaseService.UpdateExternalAppWidget(tile.banner)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Widget successfully update',
              color: 'green',
              icon: 'view-carousel'
            });
            if (!tile._PrivateData.isSliderInner) $scope.close(tile);
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget update failed',
              color: 'red',
              icon: 'view-carousel'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createWidget = function (item) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(item.banner))) {
          return;
        }

        ShowcaseService.CreateExternalAppWidget(item.banner, $scope.namespace)
          .then(function (response) {
            item.banner.id = response.widget.id;

            if (item._PrivateData.isSliderInner) {
              $scope.$parent.createNewSliderItem(item)
            } else {
              $scope.$parent.createNewTile(item);
            }
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget create failed',
              color: 'red',
              icon: 'exit-to-app'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.close = function (tile, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if ($scope.loading) return;

        if (tile.isNew) {
          $scope.$parent.deleteTile(tile, event)
        } else {
          $scope.$parent.collapseTile(tile);
        }
      };

    }]);
